import React, { useState, useEffect } from "react";
import { Menu, LogOut, ChevronDown } from "lucide-react";

export default function AdminNavbar({ sidebarOpen, setSidebarOpen, handleLogout }) {
  const [openProfile, setOpenProfile] = useState(false);
  const [username, setUsername] = useState("Pengguna");

  // ✅ Ambil username dari localStorage / sessionStorage
  useEffect(() => {
    const storedUser =
      localStorage.getItem("username") || sessionStorage.getItem("username");
    if (storedUser) setUsername(storedUser);
  }, []);

  return (
    <header className="sticky top-0 z-30 w-full bg-white/70 backdrop-blur-md border-b border-gray-200 shadow-sm transition-all">
      <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          {/* === LEFT SECTION === */}
          <div className="flex items-center gap-3">
            {/* Mobile Sidebar Toggle */}
            <button
              onClick={() => setSidebarOpen((s) => !s)}
              className="md:hidden inline-flex items-center justify-center p-2 rounded-lg hover:bg-gray-100 transition"
              aria-label="Toggle sidebar"
            >
              <Menu size={20} className="text-gray-700" />
            </button>

            {/* Logo dan Judul */}
            <div className="flex items-center gap-3">
              {/* ✅ Logo Custom */}
              <div className="w-9 h-9 rounded-xl overflow-hidden flex items-center justify-center shadow-md border border-gray-200 bg-white">
                <img
                  src="/images/foto.png"
                  alt="Logo"
                  className="w-full h-full object-contain"
                />
              </div>

              {/* Judul */}
              <div className="hidden sm:block">
                <h1 className="text-lg font-semibold leading-tight">
                  <span className="text-gray-800">Soney Raya</span>{" "}
                  <span className="text-transparent bg-clip-text bg-gradient-to-r from-green-600 to-teal-500">
                    Dashboard
                  </span>
                </h1>
                <p className="text-xs text-gray-400">Panel Manajemen Aplikasi</p>
              </div>
            </div>
          </div>

          {/* === RIGHT SECTION === */}
          <div className="flex items-center gap-2 sm:gap-4">
            {/* Profile Avatar */}
            <div className="relative">
              <button
                onClick={() => setOpenProfile((p) => !p)}
                className="flex items-center gap-2 rounded-lg px-2 py-1.5 hover:bg-gray-100 transition-all"
              >
                <img
                  src={`https://api.dicebear.com/8.x/initials/svg?seed=${username}`}
                  alt="User Avatar"
                  className="w-8 h-8 rounded-full border border-gray-300"
                />
                <ChevronDown
                  size={16}
                  className={`text-gray-500 transition-transform ${
                    openProfile ? "rotate-180" : ""
                  }`}
                />
              </button>

              {/* Dropdown Menu */}
              {openProfile && (
                <div
                  className="absolute right-0 mt-2 w-44 bg-white border border-gray-200 rounded-lg shadow-lg z-50 overflow-hidden animate-fadeIn"
                  onMouseLeave={() => setOpenProfile(false)}
                >
                  {/* === Username Info === */}
                  <div className="px-3 py-3 border-b border-gray-100 bg-gray-50">
                    <p className="text-sm font-semibold text-gray-800 capitalize">
                      {username}
                    </p>
                    <p className="text-xs text-gray-500">Akun Login</p>
                  </div>

                  {/* === Logout Button === */}
                  <button
                    onClick={handleLogout}
                    className="w-full flex items-center gap-2 px-4 py-2 text-sm text-gray-600 hover:bg-red-50 hover:text-red-600 transition"
                  >
                    <LogOut size={15} />
                    Keluar
                  </button>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}
